// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d27f6c2b","818":"45485275"}[chunkId] + ".chunk.js";
};